export default {
    values: {
        Purge: 'Expurgo',
        'Purge History': 'Histórico de Expurgo',
        'Purge rule sucessfully removed': 'Regra de expurgo removida com sucesso',
        'Failed to remove the purge rule': 'Falha ao remover a regra de expurgo',
        'There are no purge rules configured.': 'Não existem regras de expurgo configuradas.',
        'You can add a new rule to test and run a one-time data purge event.':
            'Você pode adicionar uma regra nova e executar um evento de expurgo de dados.',
        Simulate: 'Simular',
        'Run purge': 'Executar expurgo',
        Cancel: 'Cancelar',
        Recurrence: 'Recorrência',
        Action: 'Ação',
        'Event type': 'Tipo do evento',
        'Time range': 'Intervalo temporal',
        'One-Time': 'Único',
        Delete: 'Remover',
        'Add new rule': 'Adicionar nova regra',
        'No purges or simulations': 'Nenhum expurgo ou simulação',
        Date: 'Data',
        Type: 'Tipo',
        'Started by': 'Iniciado por',
        Status: 'Status',
        completed: 'completo',
        canceling: 'cancelando',
        running: 'executando',
        waiting: 'aguardando',
        failed: 'falhou',
        canceled: 'cancelado',
        Simulation: 'Simulação',
        'show more': 'mostrar mais',
        'Purge will still run in the background if you exit this page':
            'O expurgo continuará rodando em background se você sair desta página',
        'Purge rule sucessfully edited': 'Regra de expurgo editada com sucesso',
        'Failed to edit the purge rule': 'Falha ao editar a regra de expurgo',
        'Edit rule': 'Editar regra',
        'Insert an event type': 'Insira um tipo de evento',
        'Invalid event type': 'Tipo do evento inválido',
        'Add a time range': 'Adicione um intervalo temporal',
        'Invalid time range': 'Intervalo temporal inválido',
        Edit: 'Editar',
        'Purge details': 'Detalhes do expurgo',
        Yes: 'Sim',
        No: 'Não',
        'Elapsed time': 'Tempo decorrido',
        'Rules executed': 'Regras executadas',
        'Total events': 'Total de eventos',
        'Rule details': 'Detalhes das regras',
        Ok: 'Ok',
        'New purge rule sucessfully created': 'Nova regra de expurgo criada com sucesso',
        'Purge rule already exists': 'Regra de expurgo já existe',
        'Failed to create the purge rule': 'Falha ao criar a regra de expurgo',
        'New rule': 'Nova regra',
        'Executed in': 'Executou em',
        'and listed': 'e listou',
        event: 'evento',
        events: 'eventos',
        Configuration: 'Configuração',
        'Purge Settings': 'Configurações de Expurgo',
        'Failed to get the purge configuration': 'Falha ao recuperar as configurações de expurgo',
        'Settings successfully saved': 'Configurações salvas com sucesso',
        'Failed to save settings': 'Falha ao salvar as configurações',
        'Maximum duration': 'Duração máxima',
        'Value must be greater than 0': 'Valor deve ser maior que 0',
        hourString: ({ maxDuration }) => (maxDuration > 1 ? 'horas' : 'hora'),
        dayString: ({ maxDuration }) => (maxDuration > 1 ? 'dias' : 'dia'),
        minuteString: ({ maxDuration }) => (maxDuration > 1 ? 'minutos' : 'minuto'),
        Recurrent: 'Recorrente',
        'Enable scheduled rules': 'Habilitar regras agendadas',
        'This control enables/disables the execution of scheduled purge rules following the configured Cron':
            'Este controle habilta/desabilita a execução de regras agendadas seguindo o Cron configurado',
        Cron: 'Cron',
        Keep: 'Manter',
        'Exception details': 'Detalhes das exceções',
        'Purge exception already exists': 'Exceção de expurgo já existe',
        'Purge exception sucessfully edited': 'Exceção de expurgo editada com sucesso',
        'Failed to edit the purge exception': 'Falha ao editar a exceção de expurgo',
        'New purge exception sucessfully created': 'Nova exceção de expurgo criada com sucesso',
        'Failed to create the purge exception': 'Falha ao criar a exceção de expurgo',
        'Purge exception sucessfully removed': 'Exceção de expurgo removida com sucesso',
        'Failed to remove the purge exception': 'Falha ao remover a exceção de expurgo',
        'Estimated space saving': 'Estimativa de espaço liberado',
        'Message about estimated space saving':
            'O espaço efetivamente liberado depende da tecnologia de storage subjacent. Alguns providers necessitam de uma operação de vacum ou compact para liberar o espaço em disco.',
        'Additional actions available': 'Ações adicionais disponíveis',
        Executing: 'Executando',
        Executed: 'Executada',
        'Awaiting execution': 'Aguardando execução'
    }
}
